import { useCallback } from 'react';

import { createClientMutationId } from 'shared-lib';

import {
  IdentityCreateImpersonationTokenInput,
  useCreateImpersonationToken,
  useUseImpersonationToken,
} from '../mutations';

export function useImpersonateUser(): [
  (accountId: string, accountType: string) => Promise<string | null>,
  boolean,
] {
  const [createToken, isCreatingToken] = useCreateImpersonationToken();
  const [createCode, isCreatingCode] = useUseImpersonationToken();

  const onImpersonate = useCallback(
    async (accountId: string, accountType: string) => {
      const createInput: IdentityCreateImpersonationTokenInput = {
        input: {
          clientMutationId: createClientMutationId(),
        },
      };

      const createResponse = await createToken({ input: createInput });

      const token =
        createResponse.result.impersonationPayload?.model?.node.token;

      if (!token) {
        return null;
      }

      const useInput = {
        input: {
          input: {
            clientMutationId: createClientMutationId(),
            token,
            accountId,
            accountType,
          },
        },
      };

      const useResponse = await createCode(useInput);

      const code = useResponse.result.impersonationUseTokenPayload?.code;

      return code || null;
    },
    [],
  );

  return [onImpersonate, isCreatingToken || isCreatingCode];
}
